import Types from "./actionTypes";

const expandSection = id => ({
    type: Types.EXPAND,
    id,
})
const collapseSection = id => ({
    type: Types.COLLAPSE,
    id,
})

const changeLanguage = newLang => ({
    type: Types.CHANGE_LANG,
    newLang,
})

const toggleCheckBox = (buildingId, facadeId, id, box) => ({
    type: Types.SET_CHECKBOX,
    buildingId,
    facadeId,
    id,
    box,
});

const setImage = (buildingId, facadeId, imageSrc) => ({
    type: Types.SET_IMAGE_SRC,
    buildingId,
    facadeId,
    imageSrc,
});

const setDesignFeature = (buildingId, facadeId, index) => ({
    type: Types.SET_DESIGN_FEATURE,
    buildingId,
    facadeId,
    index,
})

const addBuilding = (buildingId) => ({
    type: Types.ADD_BUILDING,
    buildingId,
});
const deleteBuilding = (buildingId) => ({
    type: Types.DELETE_BUILDING,
    buildingId,
});
const setCurrentBuilding = (buildingId) => ({
    type: Types.SET_CURRENT_BUILDING,
    buildingId,
});

const setCurrentReportBuilding = (buildingId) => ({
    type: Types.SET_CURRENT_REPORT_BUILDING,
    buildingId,
});



const addFacade = (buildingId, facadeId) => ({
    type: Types.ADD_FACADE,
    buildingId,
    facadeId,
});
const deleteFacade = (buildingId, facadeId) => ({
    type: Types.DELETE_FACADE,
    buildingId,
    facadeId,
});
const setCurrentFacade = (buildingId, facadeId) => ({
    type: Types.SET_CURRENT_FACADE,
    buildingId,
    facadeId,
});


export default {
    expandSection,
    collapseSection,

    changeLanguage,
    
    toggleCheckBox,

    setImage,

    setDesignFeature,

    addBuilding,
    deleteBuilding,
    setCurrentBuilding,

    setCurrentReportBuilding,

    addFacade,
    deleteFacade,
    setCurrentFacade,
};


// WEBPACK FOOTER //
// ./src/modules/actions.js